export default __webpack_public_path__ + "static/media/web-programming.fa09320f.png";